// extracted by mini-css-extract-plugin
export default {"wrapper":"input-text_wrapper__0R6-G","icon":"input-text_icon__HCBMK","suffix":"input-text_suffix__Xvnni"};